import Vue from 'vue';
import CryptoJS from 'crypto-js';
export default {
  data() {
    return {
      missionPhoneId: '',

      dispatchTime: '',

      moveFromStationTime: '',
      tempMoveFromStationTime: '',
      showMoveFromStationTime: false,
      haveMoveFromStationTime: false,

      arriveToLocationTime: '',
      tempArriveToLocationTime: '',
      showArriveToLocationTime: false,
      haveArriveToLocationTime: false,

      moveFromLocationTime: '',
      tempMoveFromLocationTime: '',
      showMoveFromLocationTime: false,
      haveMoveFromLocationTime: false,

      arriveToHospitalTime: '',
      tempArriveToHospitalTime: '',
      showArriveToHospitalTime: false,
      haveArriveToHospitalTime: false,

      patientDeliveryTime: '',
      tempPatientDeliveryTime: '',
      showPatientDeliveryTime: false,
      havePatientDeliveryTime: false,

      finishTime: '',
      tempFinishTime: '',
      showFinishTime: false,
      haveFinishTime: false,

      arriveToStationTime: '',
      tempArriveToStationTime: '',
      showArriveToStationTime: false,
      haveArriveToStationTime: false,

      moveFromStationKM: null,
      finishKM: null,
      arriveToStationKM: null,
      firstUser: { name: '', id: null },
      secondUser: { name: '', id: null },
      thirdUser: { name: '', id: null },
      userIds_Show: [],
      missionPlaceType: '',
      serachMissionPlaceType: '',
      isWithinCity: null,
      withOutPatientFlag: false,
      //technesian Modal
      technesianModal: false,
      technesianModalTitle: '',

      technesiansList: [],
      technesianTableHeaders: [
        { text: 'نام و نام خانوادگی', value: 'fullName', align: 'center' },
        { text: 'کد ملی', value: 'personelNumber', align: 'center' },
        { text: 'شماره پرسنلی ', value: 'technecianCode', align: 'center' },
        { text: 'شماره تماس', value: 'phoneNumber', align: 'center' },
      ],
      selectedTechnesian: [],
      technesianFlag: null,
      //resultDialog
      resultDialog: false,
      withOutPatientResult: null,
      withOutPatientResultNote: '',
      patientList: [],
      patintId: null,
      disabelConfirm: false,
      searchTextTechnisian: '',
      missionTypesList: [
        {
          id: 1,
          title: 'اولیه',
        },
        {
          id: 2,
          title: 'ثانویه',
        },
      ],
      missionSecurityTypesList: [
        { title: 'بله', value: true },
        { title: 'خیر', value: false },
      ],
    };
  },
  methods: {
    cancleSetMission: function () {
      this.$router.push({ name: 'followUpMissions' });
    },
    setMissionInfo: function () {

      if (!this.finishTime?.trim()) {
        this.showSnackbar('زمان پایان ماموریت نمی تواند خالی باشد');
        return;
      }

      const timeFields = [
        { key: 'moveFromStationTime', label: 'زمان حرکت از پایگاه' },
        { key: 'arriveToLocationTime', label: 'زمان رسیدن به فوریت' },
        { key: 'moveFromLocationTime', label: 'زمان حرکت از فوریت' },
        { key: 'arriveToHospitalTime', label: 'زمان رسیدن به مرکز درمانی' },
        { key: 'patientDeliveryTime', label: 'زمان تحویل به مرکز درمانی' },
        { key: 'finishTime', label: 'زمان پایان ماموریت' },
        { key: 'arriveToStationTime', label: 'زمان رسیدن به پایگاه' },
      ];

      const validTimes = timeFields
        .map(({ key, label }) => ({ key, label, value: this[key], }))
        .filter(item => item.value && item.value.trim() !== '')
        .map(item => ({ ...item, moment: Vue.moment(item.value), }))
        .filter(item => item.moment.isValid());


      for (let i = 0; i < validTimes.length - 1; i++) {
        const current = validTimes[i];
        const next = validTimes[i + 1];

        if (current.moment.isAfter(next.moment)) {
          this.showSnackbar(`${current.label} باید قبل از ${next.label} باشد`);
          return;
        }
      }

      if (!this.userIds_Show?.length) {
        this.showSnackbar('تکنسین نمی تواند خالی باشد');
        return;
      }

      const kmFields = [
        { key: 'moveFromStationKM', label: 'کیلومتر حرکت از پایگاه' },
        { key: 'finishKM', label: 'کیلومتر پایان ماموریت' },
        { key: 'arriveToStationKM', label: 'کیلومتر رسیدن به پایگاه' },
      ];
      const validKMs = kmFields
        .map(({ key, label }) => ({ key, label, value: this[key], }))
        .filter(item => {
          if (item.value !== null && item.value !== undefined && item.value !== '') {
            const num = Number(item.value);
            if (!isNaN(num)) {
              item.value = num;
              return true;
            }
          }
          return false;
        });

      for (let i = 0; i < validKMs.length - 1; i++) {
        const current = validKMs[i];
        const next = validKMs[i + 1];
        if (current.value > next.value) {
          this.showSnackbar(
            `${next.label} باید بزرگتر یا مساوی ${current.label} باشد`
          );
          return;
        }
      }

      this.setDataByFollowUpFunction();
    },

    showSnackbar(text, color = '#FF5252') {
      this.snackText = text;
      this.snackColor = color;
      this.snakIcon = 'mdi-information';
      this.$refs.snackRef.snackModel = true;
    },
    dateTimeChange: function (type) {
      if (type == 'moveFromStationTime') {
        if (this.moveFromStationTime) {
          this.tempMoveFromStationTime = Vue.moment(this.moveFromStationTime).format(
            'HH:mm:ss jYYYY-jMM-jDD',
          );
        }
      } else if (type == 'arriveToLocationTime') {
        if (this.arriveToLocationTime) {
          this.tempArriveToLocationTime = Vue.moment(this.arriveToLocationTime).format(
            'HH:mm:ss jYYYY-jMM-jDD',
          );
        }
      } else if (type == 'moveFromLocationTime') {
        if (this.moveFromLocationTime) {
          this.tempMoveFromLocationTime = Vue.moment(this.moveFromLocationTime).format(
            'HH:mm:ss jYYYY-jMM-jDD',
          );
        }
      } else if (type == 'arriveToHospitalTime') {
        if (this.arriveToHospitalTime) {
          this.tempArriveToHospitalTime = Vue.moment(this.arriveToHospitalTime).format(
            'HH:mm:ss jYYYY-jMM-jDD',
          );
        }
      } else if (type == 'patientDeliveryTime') {
        if (this.patientDeliveryTime) {
          this.tempPatientDeliveryTime = Vue.moment(this.patientDeliveryTime).format(
            'HH:mm:ss jYYYY-jMM-jDD',
          );
        }
      } else if (type == 'finishTime') {
        if (this.finishTime) {
          this.tempFinishTime = Vue.moment(this.finishTime).format('HH:mm:ss jYYYY-jMM-jDD');
        }
      } else if (type == 'arriveToStationTime') {
        if (this.arriveToStationTime) {
          this.tempArriveToStationTime = Vue.moment(this.arriveToStationTime).format(
            'HH:mm:ss jYYYY-jMM-jDD',
          );
        }
      }
    },
    clearDateTime: function (type) {
      if (type == 'moveFromStationTime') {
        this.showMoveFromStationTime = false;
        this.moveFromStationTime = '';
        this.tempMoveFromStationTime = '';
      } else if (type == 'arriveToLocationTime') {
        this.showArriveToLocationTime = false;
        this.arriveToLocationTime = '';
        this.tempArriveToLocationTime = '';
      } else if (type == 'moveFromLocationTime') {
        this.showMoveFromLocationTime = false;
        this.moveFromLocationTime = '';
        this.tempMoveFromLocationTime = '';
      } else if (type == 'arriveToHospitalTime') {
        this.showArriveToHospitalTime = false;
        this.arriveToHospitalTime = '';
        this.tempArriveToHospitalTime = '';
      } else if (type == 'patientDeliveryTime') {
        this.showPatientDeliveryTime = false;
        this.patientDeliveryTime = '';
        this.tempPatientDeliveryTime = '';
      } else if (type == 'finishTime') {
        this.showFinishTime = false;
        this.finishTime = '';
        this.tempFinishTime = '';
      } else if (type == 'arriveToStationTime') {
        this.showArriveToStationTime = false;
        this.arriveToStationTime = '';
        this.tempArriveToStationTime = '';
      }
    },
    showTechnesianModal: function (type) {
      this.getAllTechniciansFunction();
      if (type == 1) {
        this.technesianModalTitle = 'ارشد';
        this.technesianFlag = 1;
        this.technesianModal = true;
      } else if (type == 2) {
        this.technesianModalTitle = 'اول';
        this.technesianFlag = 2;
        this.technesianModal = true;
      } else if (type == 3) {
        this.technesianModalTitle = 'دوم';
        this.technesianFlag = 3;
        this.technesianModal = true;
      }
    },
    setTechnecian: function () {
      this.technesianModal = false;

      const selectedUser = this.selectedTechnesian[0];

      const existsInShow = this.userIds_Show.some(item => item.id === selectedUser.id);
      if (!existsInShow) {
        this.userIds_Show.push({
          name: selectedUser.fullName,
          id: selectedUser.id
        });
      }


      this.selectedTechnesian = [];
      this.technesianFlag = null;
      this.technesianModalTitle = '';
      this.technesiansList = [];
      this.technesianModal = false;
      return
      // if (this.selectedTechnesian.lenght == 0) {
      //   this.snackText = 'لطفا یک مورد را انتخاب نمایید.';
      //   this.$refs.snackRef.snackModel = true;
      //   this.snackColor = '#FF5252';
      //   this.snakIcon = 'mdi-information';
      //   return;
      // }
      // if (this.firstUser.id == this.selectedTechnesian[0].id) {
      //   this.snackText = 'تکنسین انتخابی تکراری است.';
      //   this.$refs.snackRef.snackModel = true;
      //   this.snackColor = '#FF5252';
      //   this.snakIcon = 'mdi-information';
      //   return;
      // }
      // if (this.firstUser.id == this.selectedTechnesian[0].id) {
      //   this.snackText = 'تکنسین انتخابی تکراری است.';
      //   this.$refs.snackRef.snackModel = true;
      //   this.snackColor = '#FF5252';
      //   this.snakIcon = 'mdi-information';
      //   return;
      // }
      // if (this.thirdUser.id == this.selectedTechnesian[0].id) {
      //   this.snackText = 'تکنسین انتخابی تکراری است.';
      //   this.$refs.snackRef.snackModel = true;
      //   this.snackColor = '#FF5252';
      //   this.snakIcon = 'mdi-information';
      //   return;
      // }
      // if (this.technesianFlag == 1) {
      //   this.firstUser.name = this.selectedTechnesian[0].fullName;
      //   this.firstUser.id = this.selectedTechnesian[0].id;
      // } else if (this.technesianFlag == 2) {
      //   this.secondUser.name = this.selectedTechnesian[0].fullName;
      //   this.secondUser.id = this.selectedTechnesian[0].id;
      // } else if (this.technesianFlag == 3) {
      //   this.thirdUser.name = this.selectedTechnesian[0].fullName;
      //   this.thirdUser.id = this.selectedTechnesian[0].id;
      // }
      // this.selectedTechnesian = [];
      // this.technesianFlag = null;
      // this.technesianModalTitle = '';
      // this.technesiansList = [];
      // this.technesianModal = false;
    },
    cancelTechnecian: function () {
      this.selectedTechnesian = [];
      this.technesianFlag = null;
      this.technesianModalTitle = '';
      this.technesiansList = [];
      this.technesianModal = false;
    },
    getMissionPhoneOperationDetail: function (data, fieldName) {
      const fieldsArr = [];
      const getMissionBasicLocationInfo = () => {
        this.missionLocationInfo.missionPlaceType =
          data.missionPhoneOperationDetail?.missionPlaceType;
        this.missionLocationInfo.isPlaceSecure = data.missionPhoneOperationDetail?.isPlaceSecure;
        this.missionLocationInfo.placeDescription =
          data.missionPhoneOperationDetail?.placeDescription;
      };
      const firstDefaultFieldValue = data.missionPhoneOperationDetail?.isWithinCity
        ? 'درون شهری'
        : 'برون شهری';
      fieldsArr.push({ [`${fieldName}0`]: firstDefaultFieldValue });
      Object.keys(data?.missionPhoneOperationDetail ?? {})?.forEach((key) => {
        const value = data.missionPhoneOperationDetail?.[key];
        if (key.includes(fieldName) && value) {
          fieldsArr.push({ [key]: value });
        }
      });
      this.$store.dispatch('setWholeDataDispatch', fieldsArr);
      getMissionBasicLocationInfo();
    },
    //load data
    loadFollowUpMissionData: function (data) {
      if (data) {
        this.getMissionPhoneOperationDetail(data, 'placeCategory');
        if (data.missionPhoneTimeAndUser) {
          if (data.missionPhoneTimeAndUser.moveFromStationTime) {
            this.moveFromStationTime = data.missionPhoneTimeAndUser.moveFromStationTime;
            this.tempMoveFromStationTime = Vue.moment(
              data.missionPhoneTimeAndUser.moveFromStationTime,
            ).format('HH:mm:ss jYYYY-jMM-jDD');
            this.haveMoveFromStationTime = true;
          }
          if (data.missionPhoneTimeAndUser.arriveToLocationTime) {
            this.arriveToLocationTime = data.missionPhoneTimeAndUser.arriveToLocationTime;
            this.tempArriveToLocationTime = Vue.moment(
              data.missionPhoneTimeAndUser.arriveToLocationTime,
            ).format('HH:mm:ss jYYYY-jMM-jDD');
            this.haveArriveToLocationTime = true;
          }
          if (data.missionPhoneTimeAndUser.moveFromLocationTime) {
            this.moveFromLocationTime = data.missionPhoneTimeAndUser.moveFromLocationTime;
            this.tempMoveFromLocationTime = Vue.moment(
              data.missionPhoneTimeAndUser.moveFromLocationTime,
            ).format('HH:mm:ss jYYYY-jMM-jDD');
            this.haveMoveFromLocationTime = true;
          }
          if (data.missionPhoneTimeAndUser.arriveToHospitalTime) {
            this.arriveToHospitalTime = data.missionPhoneTimeAndUser.arriveToHospitalTime;
            this.tempArriveToHospitalTime = Vue.moment(
              data.missionPhoneTimeAndUser.arriveToHospitalTime,
            ).format('HH:mm:ss jYYYY-jMM-jDD');
            this.haveArriveToHospitalTime = true;
          }
          if (data.missionPhoneTimeAndUser.patientDeliveryTime) {
            this.patientDeliveryTime = data.missionPhoneTimeAndUser.patientDeliveryTime;
            this.tempPatientDeliveryTime = Vue.moment(
              data.missionPhoneTimeAndUser.patientDeliveryTime,
            ).format('HH:mm:ss jYYYY-jMM-jDD');
            this.havePatientDeliveryTime = true;
          }
          if (data.missionPhoneTimeAndUser.finishTime) {
            this.finishTime = data.missionPhoneTimeAndUser.finishTime;
            this.tempFinishTime = Vue.moment(data.missionPhoneTimeAndUser.finishTime).format(
              'HH:mm:ss jYYYY-jMM-jDD',
            );
            this.haveFinishTime = true;
          }
          if (data.missionPhoneTimeAndUser.arriveToStationTime) {
            this.arriveToStationTime = data.missionPhoneTimeAndUser.arriveToStationTime;
            this.tempArriveToStationTime = Vue.moment(
              data.missionPhoneTimeAndUser.arriveToStationTime,
            ).format('HH:mm:ss jYYYY-jMM-jDD');
            this.haveArriveToStationTime = true;
          }
          this.dispatchTime = data?.missionPhoneTimeAndUser?.dispatchTime;
          this.moveFromStationKM = data.missionPhoneTimeAndUser.moveFromStationKM
            ? data.missionPhoneTimeAndUser.moveFromStationKM
            : null;
          this.finishKM = data.missionPhoneTimeAndUser.finishKM
            ? data.missionPhoneTimeAndUser.finishKM
            : null;
          this.arriveToStationKM = data.missionPhoneTimeAndUser.arriveToStationKM
            ? data.missionPhoneTimeAndUser.arriveToStationKM
            : null;


          if (data.users) {
            const usersWithFullName = data.users?.map(user => ({
              ...user,
              name: `${user.firstName} ${user.lastName}`
            }));

            this.userIds_Show = usersWithFullName
          }

          // if (data.missionPhoneTimeAndUser.firstUser) {
          //   let fName = data.missionPhoneTimeAndUser.firstUser.firstName;
          //   let lName = data.missionPhoneTimeAndUser.firstUser.lastName;
          //   let user = fName + ' ' + lName;
          //   this.firstUser.name = user;
          //   this.firstUser.id = data.missionPhoneTimeAndUser.firstUser.id;
          // }
          // if (data.missionPhoneTimeAndUser.secondUser) {
          //   let fName = data.missionPhoneTimeAndUser.secondUser.firstName;
          //   let lName = data.missionPhoneTimeAndUser.secondUser.lastName;
          //   let user = fName + ' ' + lName;
          //   this.secondUser.name = user;
          //   this.secondUser.id = data.missionPhoneTimeAndUser.secondUser.id;
          // }
          // if (data.missionPhoneTimeAndUser.thirdUser) {
          //   let fName = data.missionPhoneTimeAndUser.thirdUser.firstName;
          //   let lName = data.missionPhoneTimeAndUser.thirdUser.lastName;
          //   let user = fName + ' ' + lName;
          //   this.thirdUser.name = user;
          //   this.thirdUser.id = data.missionPhoneTimeAndUser.thirdUser.id;
          // }
        }
        if (data.missionPhoneOperationDetail) {
          this.isWithinCity = data.missionPhoneOperationDetail.isWithinCity;
          if (data.missionPhoneOperationDetail.missionPlaceType) {
            this.serachMissionPlaceType = data.missionPhoneOperationDetail.missionPlaceType;
            this.missionPlaceType = data.missionPhoneOperationDetail.missionPlaceType;
          }
        }
        if (data.patients.length > 0) {
          this.patientList = data.patients;
          this.withOutPatientFlag = true;
        } else {
          this.patientList = [];
          this.withOutPatientFlag = false;
        }
      }
    },
    showResultDialog: function () {
      this.resultDialog = true;
    },
    setMissionWithOutPatient: function () {
      if (!this.withOutPatientResult) {
        this.snackText = 'لطفا نتیجه را انتخاب نمایید.';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (this.withOutPatientResult == 6) {
        if (!this.withOutPatientResultNote) {
          this.snackText = 'لطفا توضیحات را وارد نمایید.';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
        if (!this.withOutPatientResultNote.replace(/\s/g, '').length) {
          this.snackText = 'لطفا توضیحات را وارد نمایید.';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          this.disabelConfirm = false;
          return;
        }
      }
      this.finishMissionWithOutPatientByFollowUpFunction();
    },
    cancelSetMissionWithOutPatient: function () {
      this.withOutPatientResult = null;
      this.withOutPatientResultNote = '';
      this.resultDialog = false;
    },
    removeSelectedTechnecian: function (userId) {
      this.userIds_Show = this.userIds_Show.filter(item => item.id !== userId);
      return
      // if (type == 1) {
      //   this.firstUser = { name: '', id: null };
      // } else if (type == 2) {
      //   this.secondUser = { name: '', id: null };
      // } else if (type == 3) {
      //   this.thirdUser = { name: '', id: null };
      // }
    },
    goToPatient: function (patintId) {
      let missionPhoneeId = this.missionPhoneId.toString();
      let encryptMissionPhoneId = CryptoJS.AES.encrypt(
        missionPhoneeId,
        'sA3r5r2Dfr7lyf8N',
      ).toString();
      let id = encryptMissionPhoneId;
      if (patintId) {
        let tempPatientId = patintId.toString();
        let encryptPatientId = CryptoJS.AES.encrypt(tempPatientId, 'sA3r5r2Dfr7lyf8N').toString();
        id = id + '$$' + encryptPatientId;
      }
      this.$router.push({ name: 'followUpPatiant', params: { id: id } });
    },

    //delete patient
    showDeleteConfirmFunction: function (id) {
      this.patintId = id;
      this.confimType = 'delete';
      this.showConfirmDialogFunction();
    },
    showConfirmDialogFunction: function () {
      if (this.confimType == 'delete') {
        this.$refs.confirm.title = 'حذف مددجو';
        this.$refs.confirm.text = 'از حذف مددجو اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'delete') {
        this.disabelConfirm = true;
        this.deletePatientFunction(this.patintId);
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confimType == 'delete') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
  },
  computed: {},
};
